import { PageEvents } from '@griply/types';
import { useGoalById } from 'features/goals';
import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router';
import { useActivePath } from 'shared/hooks/use-active-path';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';

import { PageTopBar } from './components/page-top-bar';
import { getProjectRedirectUrl } from './get-project-redirect-url';
import * as Styled from './goal-detail.style';
import { OutletContext } from './outlet-context';
import { useIsProjectRoute } from './use-is-project-route';

export const GoalDetail: React.FC = () => {
  const { id } = useParams();
  const goal = useGoalById(id);
  const activePath = useActivePath();
  const isProjectRoute = useIsProjectRoute();

  // Route-derived: the goals query does not suspend, so the type arrives late.
  useTrackPageVisitEvent(
    isProjectRoute ? PageEvents.ProjectDetail : PageEvents.GoalsDetail,
    undefined,
  );
  const mainScrollRef = React.useRef<HTMLDivElement>(null);

  const redirectUrl = getProjectRedirectUrl(goal, activePath);

  if (redirectUrl) {
    return <Navigate replace to={redirectUrl} />;
  }

  return (
    <Styled.Container>
      <Styled.Main ref={mainScrollRef}>
        <PageTopBar />

        <Outlet context={{ mainScrollRef } satisfies OutletContext} />
      </Styled.Main>
    </Styled.Container>
  );
};
